module.exports = __webpack_public_path__ + "802100f939b1eed984decb6ab983789e.svg";